import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from 'assets/images/landing/arrow-right.svg'
import _imports_1 from 'assets/images/landing/crown.svg'
import _imports_2 from 'assets/images/landing/security.svg'
import _imports_3 from 'assets/images/landing/cashout.svg'
import _imports_4 from 'assets/images/landing/igtech.png'
import _imports_5 from 'assets/images/landing/playngo.png'
import _imports_6 from 'assets/images/landing/betsoft.png'
import _imports_7 from 'assets/images/landing/amatic.png'
import _imports_8 from 'assets/images/landing/booming.png'
import _imports_9 from 'assets/images/landing/licky.png'
import _imports_10 from 'assets/images/landing/platipus.png'
import _imports_11 from 'assets/images/landing/belatra.png'
import _imports_12 from 'assets/images/landing/mc.png'
import _imports_13 from 'assets/images/landing/skrill.png'
import _imports_14 from 'assets/images/landing/netelller.png'
import _imports_15 from 'assets/images/landing/neosurf.png'
import _imports_16 from 'assets/images/landing/bitcoin.png'
import _imports_17 from 'assets/images/landing/ecopayz.png'


const _hoisted_1 = ["data-theme"]
const _hoisted_2 = { class: "promo-page-first-block" }
const _hoisted_3 = {
  key: 0,
  class: "promo-page-australia-banner-desktop"
}
const _hoisted_4 = ["src", "width", "height"]
const _hoisted_5 = {
  key: 1,
  class: "promo-page-australia-banner-mobile"
}
const _hoisted_6 = ["src", "width", "height"]
const _hoisted_7 = { class: "promo-page-australia-reg-area" }
const _hoisted_8 = { class: "promo-page-step" }
const _hoisted_9 = { class: "promo-page-step__wrapper" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "step-arrow" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "step-arrow-img",
    src: _imports_0,
    alt: "arrow-right"
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "step-arrow" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "step-arrow-img",
    src: _imports_0,
    alt: "arrow-right"
  })
], -1)
const _hoisted_12 = { class: "promo-page-step-icon" }
const _hoisted_13 = { class: "promo-page-step-icon__circle" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "promo-page-step-icon__circle-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "crown"
  })
], -1)
const _hoisted_15 = { class: "promo-page-step-icon__circle" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "promo-page-step-icon__circle-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "crown"
  })
], -1)
const _hoisted_17 = { class: "promo-page-step-icon__circle" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "promo-page-step-icon__circle-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: "crown"
  })
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "promo-page-step-logos" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "promo-page-step-logos__top" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "promo-page-step-logos__img igtech",
      src: _imports_4,
      alt: "igtech"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "promo-page-step-logos__img playngo",
      src: _imports_5,
      alt: "playngo"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "promo-page-step-logos__img betsoft",
      src: _imports_6,
      alt: "betsoft"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "promo-page-step-logos__img amatic",
      src: _imports_7,
      alt: "amatic"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "promo-page-step-logos__img booming",
      src: _imports_8,
      alt: "booming"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "promo-page-step-logos__img licky",
      src: _imports_9,
      alt: "licky"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "promo-page-step-logos__img platipus",
      src: _imports_10,
      alt: "platipus"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "promo-page-step-logos__img belatra",
      src: _imports_11,
      alt: "belatra"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "promo-page-step-logos__img igtech",
      src: _imports_4,
      alt: "igtech"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "promo-page-step-logos__img igtech",
      src: _imports_4,
      alt: "igtech"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "promo-page-step-logos__bottom" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "promo-page-step-logos__img mc",
      src: _imports_12,
      alt: "mc"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "promo-page-step-logos__img skrill",
      src: _imports_13,
      alt: "skrill"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "promo-page-step-logos__img netelller",
      src: _imports_14,
      alt: "netelller"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "promo-page-step-logos__img neosurf",
      src: _imports_15,
      alt: "neosurf"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "promo-page-step-logos__img bitcoin",
      src: _imports_16,
      alt: "bitcoin"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      class: "promo-page-step-logos__img ecopayz",
      src: _imports_17,
      alt: "ecopayz"
    })
  ])
], -1)

import { toRefs } from 'vue';
import { useCommonPromo } from '@/composables/useCommonPromo';
import Markdown from '@/components/markdown.vue';
import PromoPageRegForm from '@/components/promoPageRegForm.vue';
import { PromoPageInterface } from '~/types/promoPage.interface';


export default /*#__PURE__*/_defineComponent({
  props: {
    pageData: null
  },
  setup(__props: any) {

const props = __props as {
  pageData: PromoPageInterface;
}



const {
  theme,
  targetHost,
  currency,
  promoLoader,
  onlyCrypto,
  bannerDesktop,
  bannerMobile,
  isDesktop,
  isMobile,
  lang,
} = useCommonPromo(props);

const {
  first_step: firstStep,
  second_step: secondStep,
  third_step: thirdStep,
  year_text: yearText,
  fair_text: fairText,
  cashout_text: cashoutText,
} = toRefs(props.pageData.params[0]);

return (_ctx: any,_cache: any) => {
  return (__props.pageData)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "promo-page promo-page-australia",
        "data-theme": _unref(theme)
      }, [
        _createElementVNode("div", _hoisted_2, [
          (_unref(isDesktop))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_unref(bannerDesktop))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _unref(bannerDesktop).url,
                      width: _unref(bannerDesktop).width,
                      height: _unref(bannerDesktop).height
                    }, null, 8, _hoisted_4))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_unref(isMobile))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_unref(bannerMobile))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _unref(bannerMobile).url,
                      width: _unref(bannerMobile).width,
                      height: _unref(bannerMobile).height
                    }, null, 8, _hoisted_6))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(PromoPageRegForm, {
              class: "promo-page-australia-reg-form",
              lang: _unref(lang),
              "promo-loader": _unref(promoLoader),
              "crypto-only": _unref(onlyCrypto),
              "preselected-currency": _unref(currency),
              "target-host": _unref(targetHost)
            }, null, 8, ["lang", "promo-loader", "crypto-only", "preselected-currency", "target-host"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(Markdown, {
              text: _unref(firstStep),
              class: "promo-page-australia-step"
            }, null, 8, ["text"]),
            _hoisted_10,
            _createVNode(Markdown, {
              text: _unref(secondStep),
              class: "promo-page-australia-step"
            }, null, 8, ["text"]),
            _hoisted_11,
            _createVNode(Markdown, {
              text: _unref(thirdStep),
              class: "promo-page-australia-step"
            }, null, 8, ["text"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(Markdown, {
              text: _unref(yearText),
              class: "promo-page-australia-step"
            }, null, 8, ["text"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(Markdown, {
              text: _unref(fairText),
              class: "promo-page-australia-step"
            }, null, 8, ["text"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(Markdown, {
              text: _unref(cashoutText),
              class: "promo-page-australia-step"
            }, null, 8, ["text"])
          ])
        ]),
        _hoisted_19
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})